import { useQuery } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'

const defaultResponseDataProcessor = response => response.data

export function useGetCurrent (
  resourceName,
  version = 2,
  responseDataProcessor = defaultResponseDataProcessor
) {
  return useQuery({
    queryKey: ['current', resourceName, version],
    queryFn: async () => {
      const client = await getApi('schools', { version })
      const response = await client.get(`/${resourceName}`)
      return responseDataProcessor(response)
    },
    staleTime: 5 * 60 * 1000
  })
}
